import Box from "@mui/material/Box";
import { CircularProgress, Grid, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import useStyles from "./../../styles/styles";
import { Branch, BranchApi, GetBranchesResponse, GetBranchesResponseInner } from "../../api/clinic-management";
import { configState, loggedEmployee } from "../../recoil/atoms";
import { useRecoilValue } from "recoil";
import { Card, CardActionArea, CardContent } from "@mui/material";
import { Link } from "react-router-dom";
import useAuthorization from "../Authentication/permissions/Authorization";
import MainCard from "../../styles/ui-component/cards/MainCard";
import { toast } from "react-toastify";

const Branches = () => {
  const [branches, setBranches] = useState<GetBranchesResponse>([]);
  const [chosenBranch, setChosenBranch] = useState<Branch>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { canGetTenantBranches } = useAuthorization();
  const classes = useStyles();

  const config = useRecoilValue(configState);
  const loggedInEmployee = useRecoilValue(loggedEmployee);

  const getBranches = () => {
    const branch = new BranchApi(config);
    branch
      .getBranchsofTenant(loggedInEmployee.TenantID!)
      .then((res) => {
        setBranches(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  useEffect(() => {
    getBranches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <MainCard>
        {canGetTenantBranches && (!isLoading ? (
          <Grid container spacing={2} direction="row" alignItems="center" justifyContent="center">
            {branches.map((branch: GetBranchesResponseInner) => {
                return (
                  <Grid item xs={6} md={3}>
                    <Link to={`/branch/${branch.BranchID}`} style={{ textDecoration: "none" }}>
                      <Card>
                        <CardActionArea
                          href=""
                          style={{ display: "flex", justifyContent: "center" }}
                          className={chosenBranch === branch ? classes.pressedButton : classes.unPressedButton}
                          onClick={() => {
                            setChosenBranch(branch);
                          }}
                        >
                          <CardContent>
                            <Typography>{branch.Name}</Typography>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    </Link>
                  </Grid>
                );
              })}
          </Grid>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress color="secondary" size={36} />
          </Box>
        ))}
      </MainCard>
    </>
  );
};

export default Branches;
